__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/76daa7b/_next/";